<script>
import AssetMetadata from "@wielink-application/asset/js/mixins/assetMetadata";

export default {
    mixins: [AssetMetadata],
    props: {
        form: {
            type: Object,
            required: true
        },
        assetableGroup: {
            type: String,
            required: false,
            default: null
        }
    },
    methods: {
        async loadMetadata(group) {
            await this.fetchMetadataFields(group);
        },
    }
}
</script>

<template>
   <!-- Metadata velden -->
    <template v-if="loadingMetadata">
        <div class="alert alert-info d-flex align-items-center gap-2">
            <i class="fas fa-spinner fa-spin"></i>
            <span>Metadata velden laden...</span>
        </div>
    </template>

    <template v-else-if="metadataFields.length > 0">
        <component
            v-for="field in metadataFields"
            :key="field.name"
            :is="getComponentForField(field)"
            v-model="form.metadata[field.name]"
            :form="form"
            :name="`metadata[${field.name}]`"
            :label="field.label"
            :required="field.required"
            :placeholder="field.placeholder"
        />
    </template>
</template>